import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    path: 'id',
    context: 'sort_filter',
  })

  let selected = useDataValue({
    viewPath: props.viewPath,
    path: 'selected',
    context: 'sort',
  })

  let change = useDataChange({
    context: 'sort',
    path: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let value = {
      ...Object.fromEntries(Object.keys(selected).map(key => [key, null])),
      [id]: 'desc',
    }
    change(value)
  }
}

export function isSelected(selected, id) {
  return selected[id] === 'desc'
}

export function getText(value) {
  if (value === 'due_date') {
    return `Due date most recent first`
  }
  if (value === 'priority') {
    return `Priority Urgent first`
  }
  if (value === 'created_at') {
    return `Created date most recent first`
  }
}
